import { DATAGRIDPRO_DEFAULTS, DATE_VALUE_GETTER } from '@admin-const';
import { Box } from '@mui/material';
import { DataGridPro, GridColDef, GridPaginationModel } from '@mui/x-data-grid-pro';
import { RootState } from '@store';
import { UserProject } from '@types';
import { memo, useCallback, useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import AutoSizer from '@components/AutoSizer';

export interface BaseUserTableProps {
  data?: UserProject[];
}

const BaseUserTable = ({ data }: BaseUserTableProps) => {
  const { useUtcTime, use24HourFormat } = useSelector(
    (state: RootState) => ({
      useUtcTime: state.admin.useUtcTime,
      use24HourFormat: state.admin.use24HourFormat
    }),
    shallowEqual
  );
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 5
  });

  const handlePaginationModelChange = useCallback((newModel: GridPaginationModel) => {
    setPaginationModel(newModel);
  }, []);

  const columns = useMemo(() => {
    const columns: GridColDef[] = [
      { field: 'name', headerName: 'Name', width: 200 },
      { field: 'role', headerName: 'Seat type', width: 120 },
      { field: 'owner', headerName: 'Owner', width: 200 },
      { field: 'status', headerName: 'Status', width: 120 },
      {
        field: 'created_at',
        headerName: 'Created At',
        width: use24HourFormat ? 200 : 220,
        valueGetter: (value) => DATE_VALUE_GETTER(value, useUtcTime, use24HourFormat)
      },
      { field: 'last_run', headerName: 'Last Active', width: use24HourFormat ? 200 : 220, valueGetter: (value) => DATE_VALUE_GETTER(value, useUtcTime, use24HourFormat) }
    ];
    return columns;
  }, [useUtcTime, use24HourFormat]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '300px'
      }}
    >
      <AutoSizer>
        {({ height, width }) => (
          <DataGridPro
            // \n
            {...DATAGRIDPRO_DEFAULTS}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            getRowId={(row) => row.id}
            density="compact"
            columns={columns}
            rows={data || []}
            style={{ height, width }}
            hideFooter={false}
            pagination
            paginationMode="client"
            pageSizeOptions={[5, 10, 25, 50]}
          />
        )}
      </AutoSizer>
    </Box>
  );
};

export default memo(BaseUserTable);
